import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import EfImg from '@elem/ui/ef-img';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale } = useRouter();

    const IS_AU = locale === 'au';

    const configs = {
        pc: IS_AU ? 'https://websiteoss.ecoflow.com/upload/image/1737619306462/KV-pc.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1724643356078/b1.jpg',
        h5: IS_AU ? 'https://websiteoss.ecoflow.com/upload/image/1737619306295/KV-h5.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1724643355937/b2.jpg',
        label: t('C_label'),
        title: t('C_title'),
        subTitle: t('C_subTitle'),
    };

    return (
        <div className={styles.TheComp}>
            <EfSection {...configs} theme="white" position="hover" />
        </div>
    );
}
